import { marketingAdministratorRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/static-marketing-list";

const targetedAtOptions = [
  { Key: 1, Value: "Account" },
  { Key: 2, Value: "Contact" },
];

/**
 * The static marketing lists list. Every list comes back in one request, so its
 * filters narrow what is already loaded rather than asking again.
 */
export const marketingListsListDefinition: ListDefinition = {
  path: "/static-marketing-lists",
  entityName: "list",
  recordRoute,
  title: "Static Marketing Lists",
  allowedRoles: marketingAdministratorRoles,
  data: "all-at-once",
  filters: [
    {
      name: "Name",
      label: "Name",
      kind: "text",
      searchFields: ["Name"],
      width: "wide",
    },
    {
      name: "createdfromcode",
      label: "Targeted At",
      kind: "picklist",
      options: targetedAtOptions,
    },
    {
      name: "g4c_issubscription",
      label: "Subscription Only",
      kind: "boolean",
      toggle: true,
      advanced: true,
    },
    {
      name: "membercount",
      label: "Member Count",
      kind: "number",
      advanced: true,
    },
    {
      name: "createdon",
      label: "Created",
      kind: "date-range",
      advanced: true,
    },
    {
      name: "modifiedon",
      label: "Modified",
      kind: "date-range",
      advanced: true,
    },
  ],
  filterByStatus: true,
  allowAdd: true,
  allowStatusEdit: true,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "createdfromcode",
      label: "Targeted At",
      width: 200,
      display: "picklist",
      options: targetedAtOptions,
      sortable: true,
    },
    {
      key: "g4c_issubscription",
      label: "Is Subscription",
      width: 200,
      display: "yesno",
      sortable: true,
    },
    {
      key: "membercount",
      label: "Member Count",
      width: 200,
      display: "number",
      sortable: true,
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
